import { render, staticRenderFns } from "./ropeningbalance.vue?vue&type=template&id=a8a2ce62&scoped=true&"
import script from "./ropeningbalance.vue?vue&type=script&lang=js&"
export * from "./ropeningbalance.vue?vue&type=script&lang=js&"
import style0 from "./ropeningbalance.vue?vue&type=style&index=0&id=a8a2ce62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a2ce62",
  null
  
)

export default component.exports